import React from "react";
import { IoMdCall } from "react-icons/io";
import "./AboutUs.css";
import { IoTelescope } from "react-icons/io5";
import { SiTarget } from "react-icons/si";
import ImageWithSkeleton from "./ImageWithSkeleton";
import Counter from "./Counter";

function AboutUs() {
  const stats = [
    { target: 15, suffix: "+", label: "Years in Business" },
    { target: 500, suffix: "+", label: "Happy Farmers" },
    { target: 14, suffix: "+", label: "Awards Won" },
    { target: 14, suffix: "+", label: "Brand Partners" }
  ];

  const owners = [
    {
      name: "Chandu Faldu",
      designation: "Founder & Owner",
      expert: "35+ Years Experience",
      phone: "+91 97732 55243",
      image: "/assets/owner/chandu.jpeg",
      whatsappUrl: `https://wa.me/919426212650?text=${encodeURIComponent("નમસ્તે, હું વિનાયક એગ્રો કેમિકલ્સના ઉત્પાદનો વિશે માહિતી અને ઉપલબ્ધતા જાણવા માંગું છું. કૃપા કરીને માર્ગદર્શન આપશો.")}`,
      callUrl: "tel:+919773255243"
    },
    {
      name: "Jaydip Faldu",
      designation: "CEO & Managing Director",
      expert: "15+ Years Experience",
      phone: "+91 82641 91234",
      image: "/assets/owner/jaydip.jpeg",
      whatsappUrl: `https://wa.me/918264191234?text=${encodeURIComponent("નમસ્તે, હું વિનાયક એગ્રો કેમિકલ્સના ઉત્પાદનો વિશે માહિતી અને ઉપલબ્ધતા જાણવા માંગું છું. કૃપા કરીને માર્ગદર્શન આપશો.")}`,
      callUrl: "tel:+918264191234"
    }
  ];

  return (
    <div className="about-page-container">
      {/* Page Hero Banner */}
      <div className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">About Vinayak Agro Chemicals</h1>
          <p className="page-subtitle">Serving farmers of Gujarat since years</p>
        </div>
      </div>

      {/* Company Story Section */}
      <section className="about-section">
        <div className="about-container">
          <span className="section-tag">Our Story</span>
          <h2 className="section-title">About the Company</h2>
          <div className="about-columns">
            <div className="about-text-column">
              <p className="about-intro">
                Welcome to Vinayak Agro Chemicals. We are a trusted shop based in Bhavnagar, Gujarat, dedicated to helping farmers grow better and healthier crops.
              </p>
              <p className="about-description">
                We know that farming is hard work. That is why we provide only the best quality seeds and farm chemicals. We act as a bridge between big, famous companies and the local farmer. When you buy from us, you can be sure you are getting 100% original products.
              </p>
            </div>
            <div className="about-image-column">
              <div className="shop-photo-placeholder">
                <ImageWithSkeleton
                  src="/assets/logo.jpg"
                  alt="Vinayak Agro Chemicals Shop"
                  className="shop-photo-img"
                  fallbackIcon="🏢"
                  fallbackClassName="shop-photo-fallback"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Milestones Strip */}
      <section className="milestones-strip">
        <div className="milestones-container">
          {stats.map((stat, idx) => (
            <div key={idx} className="milestone-card">
              <div className="milestone-number">
                <Counter target={stat.target} suffix={stat.suffix} />
              </div>
              <div className="milestone-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Leadership / Owner Section */}
      <section className="owners-section">
        <div className="owners-container">
          <span className="section-tag">Leadership</span>
          <h2 className="section-title">Meet the Owners</h2>
          <p className="section-subtitle">Pioneering agricultural excellence in Bhavnagar</p>
          <div className="owners-grid">
            {owners.map((owner, idx) => (
              <div key={idx} className="owner-card">
                <div className="owner-header">
                  <div className="owner-photo-placeholder">
                    <ImageWithSkeleton
                      src={owner.image}
                      alt={owner.name}
                      className="owner-photo-img"
                      fallbackIcon={owner.name.split(' ').map(n => n[0]).join('')}
                      fallbackClassName="owner-photo-initials"
                    />
                  </div>
                  <div className="owner-meta">
                    <h3 className="owner-name">{owner.name}</h3>
                    <p className="owner-designation">{owner.designation}</p>
                    <p className="owner-expert">{owner.expert}</p>
                  </div>
                </div>
                <div className="owner-body">
                  <p className="owner-phone"><IoMdCall /> {owner.phone}</p>
                  <div className="owner-actions">
                    <a href={owner.whatsappUrl} target="_blank" rel="noopener noreferrer" className="owner-btn whatsapp-action">
                      WhatsApp
                    </a>
                    <a href={owner.callUrl} className="owner-btn call-action">
                      Call Now
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-vision-section">
        <div className="mission-vision-container">
          <span className="section-tag">Values</span>
          <h2 className="section-title">Mission & Vision</h2>
          <div className="mission-vision-grid">
            <div className="value-card">
              <div className="value-icon"><SiTarget size={43} /></div>
              <h3 className="value-title">Our Mission</h3>
              <p className="value-text">
                To provide 100% original quality agrochemicals and seeds to farmers of Gujarat at fair prices with expert guidance.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon"><IoTelescope size={43} /></div>
              <h3 className="value-title">Our Vision</h3>
              <p className="value-text">
                To be the most trusted agro distributor in Saurashtra, empowering every farmer for a better harvest.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
